import { useIsUserInRole, selectedDatabaseIdState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { Redirect } from 'react-router-dom';
import TabbedSubnav from '@src/components/shared/TabbedSubnav';

export default function MainNav() {
  const rcaId = useRecoilValue(selectedDatabaseIdState);

  // Role checks
  const isDeveloper = useIsUserInRole('Developer');
  const isTtmAdmin = useIsUserInRole('TTMAdmin');
  const isGlobalQuarterlyReporting = useIsUserInRole('QuarterlyReporting');
  const isGlobalAdmin = useIsUserInRole('Admin');
  const isNztaAudit = useIsUserInRole('NZTAAudit');
  const isRcaQuarterlyReporting = useIsUserInRole(`db:${rcaId}:QuarterlyReporting`);
  const isRcaTtmSiteCapture = useIsUserInRole(`db:${rcaId}:TTMSiteCapture`);
  const isRcaAdmin = useIsUserInRole(`db:${rcaId}:Admin`);
  const hasRcaRole = isRcaQuarterlyReporting || isRcaAdmin;

  // Redirect TTMAdmin if no RCA access and not a developer
  if (!hasRcaRole && !isDeveloper && isTtmAdmin) {
    return <Redirect to="/performance/quarterly-reporting/admin-report" />;
  }

  // Build tabs based on roles
  const tabs = [];

  if (isDeveloper || hasRcaRole || isGlobalQuarterlyReporting || isGlobalAdmin || isNztaAudit || isRcaTtmSiteCapture) {
    tabs.push(
      { label: 'Temporary Traffic Management', path: 'temporary-traffic-management' },
    );
  }

  if (isDeveloper || hasRcaRole || isGlobalQuarterlyReporting || isGlobalAdmin || isNztaAudit) {
    tabs.push(
      { label: 'Potholes', path: 'potholes' },
    );
  }

  if (isTtmAdmin || isDeveloper || isNztaAudit) {
    tabs.push({ label: 'Admin Report', path: 'admin-report' });
  }

  if (tabs.length === 0) return null; // No tabs to show, return null

  return (
    <TabbedSubnav
      tabs={tabs}
      mx={4}
      mb={6}
    />
  );
}
